import { useAppSelector } from 'app/store/configureStore';
import {
  getInvitesList,
  getInvitesLoadingState,
  getInvitesMoreLoadingState,
  getInvitesNextLink,
  getNotificationsList,
  getNotificationsLoadingState,
  getUnseenInviteCount,
  getUnseenNotificationCount,
} from 'app/store/Notifications/selectors';
import { isLoading } from 'app/utils/utils';
import { LoadingState } from 'types/enums';
import { useState } from 'react';

export const useNotificationsComponentData = () => {
  const notifications = useAppSelector(getNotificationsList);
  const invites = useAppSelector(getInvitesList);
  const moreInvitesLink = useAppSelector(getInvitesNextLink);
  const notificationsLoadingState = useAppSelector(
    getNotificationsLoadingState
  );
  const invitesLoadingState = useAppSelector(getInvitesLoadingState);
  const isInvitesLoading = isLoading(invitesLoadingState);
  const isNotificationsLoading = isLoading(notificationsLoadingState);
  const isLoadingMoreInvites =
    useAppSelector(getInvitesMoreLoadingState) === LoadingState.FETCHING;
  const unseenNotificationsCount = useAppSelector(getUnseenNotificationCount);
  const [
    originalUnseenNotifications,
    setOriginalUnseenNotifications,
  ] = useState(unseenNotificationsCount);
  const unseenInvitesCount = useAppSelector(getUnseenInviteCount);
  const [originalUnseenInvites, setOriginalUnseenInvites] = useState(
    unseenInvitesCount
  );
  const showLoader =
    (!notifications.length || !invites.length) &&
    (isNotificationsLoading || isInvitesLoading);
  const [showInactiveInviteDialog, setShowInactiveDialog] = useState(false);
  const [invalidInviteMessage, setInvalidInviteMessage] = useState('');

  return {
    notifications,
    invites,
    notificationsLoadingState,
    invitesLoadingState,
    isLoadingMoreInvites,
    originalUnseenNotifications,
    unseenNotificationsCount,
    originalUnseenInvites,
    unseenInvitesCount,
    showLoader,
    showInactiveInviteDialog,
    invalidInviteMessage,
    moreInvitesLink,
    setOriginalUnseenNotifications,
    setOriginalUnseenInvites,
    setShowInactiveDialog,
    setInvalidInviteMessage,
  };
};
